import { Injectable } from '@angular/core';
import API, { graphqlOperation } from '@aws-amplify/api';

export interface User {
  username: string;
  firstname: string;
  lastname: string;
  email: string;
  userCompany: string | null;
  acl: string | null;
  group: string;
  role: string;
  active: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class UserApiService {
  async Me(): Promise<User> {
    const statement = `query Me {
        me {
          username
          firstname
          lastname
          email
          userCompany
          acl
          group
          role
          active
        }
      }`;
    const response = (await API.graphql(graphqlOperation(statement))) as any;
    return response.data.me as User;
  }
}
